import * as React from 'react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { CtaDescription } from 'modules/expenses/components/common/CardsHero'

import CardsLandingPageContent from './Content'

const SUPPORT_EMAIL_ADDRESS = 'product.support@factorial.co'

interface Props {
  ctaDescription: CtaDescription
}

const CardsLandingPage: React.FC<Props> = ({ ctaDescription }) => {
  const onContactSupportClick = () => {
    window.location.href = `mailto:${SUPPORT_EMAIL_ADDRESS}`
  }

  const onFAQCardClick = (question: string) => {
    track(trackingEvents.expenses.faqDropdownCardClicked, { question })
  }

  return (
    <CardsLandingPageContent
      ctaDescription={ctaDescription}
      onContactSupportClick={onContactSupportClick}
      onFAQCardClick={onFAQCardClick}
    />
  )
}

export default CardsLandingPage
